import { render, staticRenderFns } from "./AddressStep.vue?vue&type=template&id=3af77b47&scoped=true"
import script from "./AddressStep.vue?vue&type=script&lang=js"
export * from "./AddressStep.vue?vue&type=script&lang=js"
import style0 from "./AddressStep.vue?vue&type=style&index=0&id=3af77b47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af77b47",
  null
  
)

export default component.exports